import { Button, Modal, Select } from 'antd';
import { CaretDownFilled } from '@ant-design/icons';
import React, { useState } from 'react';
import type { ExportFormat } from '../../../hooks/useDownload';
import './DownloadDatasetModal.scss';

interface DownloadDatasetModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
  onDownload: (format: ExportFormat) => void;
}

const FORMAT_OPTIONS: { value: ExportFormat; label: string }[] = [
  { value: 'shapefile', label: 'SHAPEFILE' },
  { value: 'csv', label: 'CSV' },
  { value: 'kml', label: 'KML' },
];

const DownloadDatasetModal: React.FC<DownloadDatasetModalProps> = ({ open, title, onClose, onDownload }) => {
  const [format, setFormat] = useState<ExportFormat | undefined>();

  const handleDownloadClick = () => {
    if (!format) return;
    onDownload(format);
    onClose();
  };

  return (
    <Modal mask={false} className="downloadDatasetModal" title={title} open={open} onCancel={onClose} footer={null} centered destroyOnClose>
      <div className="downloadDatasetModal__row">
        <Select
          className="downloadDatasetModal__select"
          popupClassName="downloadDatasetModal__dropdown"
          placeholder="CHOOSE"
          suffixIcon={<CaretDownFilled />}
          value={format}
          onChange={setFormat}
          options={FORMAT_OPTIONS}
        />
        <Button className="downloadDatasetModal__downloadBtn" disabled={!format} onClick={handleDownloadClick}>
          Download
        </Button>
      </div>
    </Modal>
  );
};

export default DownloadDatasetModal;
